exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".send-sources-icon {\n  enable-background:new 0 0 122.88 105.98;\n}", ""]);
